import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'MODALS/DIRECT_DEBIT_EXPORT';
export const {action: show} = createAction(`${domain}/SHOW`, (institutionId, invoiceIds) => ({
    institutionId,
    invoiceIds,
}));

export const {
    action: getFile,
    success: getFileSuccess,
    failed: getFileFailed,
} = createAction(`${domain}/GET_FILE`, (invoiceIds, addPayments) => ({invoiceIds, addPayments}));

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));

export const {action: toggleAddPayments} = createAction(`${domain}/TOGGLE_ADD_PAYMENTS`, addPayments => ({
    addPayments,
}));
